import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PolitiqueCookies = () => {
    const lastUpdate = "9 septembre 2025";

    const sections = [
        {
            id: "definition",
            title: "1. Qu’est-ce qu’un cookie ?",
            content: `Un cookie est un petit fichier texte enregistré sur votre appareil (ordinateur, smartphone, tablette) lors de la visite d’un site internet.
      Il permet notamment de :
      • Faciliter la navigation,
      • Mémoriser vos préférences,
      • Mesurer l’audience du site,
      • Proposer des contenus personnalisés.`,
        },
        {
            id: "types",
            title: "2. Types de cookies utilisés",
            content: `• Cookies techniques : indispensables au fonctionnement du site (ex. session, sécurité).
      • Cookies de mesure d’audience : permettent de suivre la fréquentation et d’améliorer nos services (ex. Google Analytics).
      • Cookies publicitaires (si applicable) : servent à proposer des publicités ciblées.`,
        },
        {
            id: "consentement",
            title: "3. Gestion du consentement",
            content: `Lors de votre première visite sur le site, un bandeau vous informe de l’utilisation des cookies.
      Vous pouvez :
      • Accepter tous les cookies,
      • Refuser tous les cookies non essentiels,
      • Personnaliser vos choix.
      Votre choix est conservé pendant 6 mois maximum.`,
        },
        {
            id: "desactivation",
            title: "4. Désactivation des cookies",
            content:
                "Vous pouvez à tout moment désactiver les cookies dans les paramètres de votre navigateur (Chrome, Firefox, Safari, Edge, etc.).",
        },
        {
            id: "contact",
            title: "5. Contact",
            content:
                "Pour toute question relative aux cookies, vous pouvez nous écrire à : contact@gestionfreelance.com.",
        },
    ];

    return (
        <>
            <Navbar />
            <main
                className="min-h-screen bg-white font-Poppins lg:pt-20 pt-10"
                id="cookies"
            >
                <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
                    {/* En-tête */}
                    <header className="mb-12 text-start">
                        <h1 className="text-3xl sm:text-4xl font-bold lg:text-5xl font-Poppins tracking-tight text-color1 mb-3">
                            Politique de cookies
                        </h1>
                        <p className="text-sm sm:text-base text-gray-600 font-thin">
                            Dernière mise à jour&nbsp;: {lastUpdate}
                        </p>
                    </header>

                    {/* Sommaire */}
                    <nav
                        aria-label="Sommaire"
                        className="mb-10 rounded-2xl border border-color3 p-6 shadow-sm font-Poppins"
                    >
                        <h2 className="text-lg font-semibold text-color1 mb-4">Sommaire</h2>
                        <ul className="grid gap-3 sm:grid-cols-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href={`#${s.id}`}
                                        className="text-sm sm:text-base text-gray-700 hover:underline"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contenu */}
                    <div className="space-y-12">
                        {sections.map((s) => (
                            <section key={s.id} id={s.id}>
                                <h3 className="text-2xl sm:text-3xl font-bold text-color1 mb-4 text-start font-Poppins">
                                    {s.title}
                                </h3>
                                <p className="text-gray-700 text-base sm:text-lg leading-relaxed text-justify font-Poppins whitespace-pre-line">
                                    {s.content}
                                </p>
                            </section>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default PolitiqueCookies;
